export default __webpack_public_path__ + "static/futuraBook-4e77bd0de198485168a119667f3d17d2.png";